import { useEffect } from 'react'

/**
 * bind enter key to a form event
 */
export function useFormEnter(formId: string, action: (e: KeyboardEvent) => void) {
  //
  useEffect(() => {
    const keyDownHandler = (e: KeyboardEvent) => {
      const target = e.target as HTMLDivElement
      const form = target.closest(`#${formId}`)
      if (e.key === 'Enter' && form) {
        e.preventDefault()
        action(e)
      }
    }

    document.addEventListener('keydown', keyDownHandler)
    return () => {
      document.removeEventListener('keydown', keyDownHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formId])
}
